import { render, staticRenderFns } from "./DashboardCardView.vue?vue&type=template&id=6b479672"
import script from "./DashboardCardView.vue?vue&type=script&lang=js"
export * from "./DashboardCardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports